import React, { forwardRef } from 'react';
import { Grid, Card, IconCircle, CardLabel, Check, Toggle } from './ChoiceCard.styles';

/** role="group" grid of choice cards. `locked` blocks double taps while advancing. */
export const ChoiceGrid = ({ labelledBy, locked = false, id, children }) => (
    <Grid role="group" aria-labelledby={labelledBy} locked={locked} id={id}>
        {children}
    </Grid>
);

/** Category card: a `<button aria-pressed>` that selects and advances. */
export const ChoiceCard = forwardRef(({ icon, label, selected = false, appear, onSelect }, ref) => (
    <Card
        ref={ref}
        type="button"
        aria-pressed={selected}
        isSelected={selected}
        appear={appear}
        onClick={onSelect}
    >
        <IconCircle isSelected={selected} aria-hidden="true">
            <i className={icon} />
        </IconCircle>
        <CardLabel>{label}</CardLabel>
        {selected && (
            <Check aria-hidden="true">
                <i className="ri-check-line" />
            </Check>
        )}
    </Card>
));

/** "Ver más categorías" toggle. */
export const ExpandToggle = ({ expanded, onToggle, controls, label }) => (
    <Toggle
        type="button"
        aria-expanded={expanded}
        aria-controls={controls}
        expanded={expanded}
        onClick={onToggle}
    >
        <span>{label}</span>
        <i className="ri-arrow-down-s-line" aria-hidden="true" />
    </Toggle>
);
